import axios from "axios";

import { PRE_REGISTRATION_API_URL } from "../config/apiConfig";

/**
 * Pièces du compte connecté (schema-based-tenant-pre-registration, /representant/me/documents) :
 * l'inscription n'en exige plus, elles se déposent depuis l'espace du compte.
 * `skipSessionExpiry` : un 401 de ce service (clé publique non configurée…) ne déconnecte pas.
 */
const client = axios.create({ baseURL: PRE_REGISTRATION_API_URL });

export const DOCUMENTS_PATH = "/account/documents";
export const ACCEPTED_MIME_TYPES = ["application/pdf", "image/jpeg", "image/png"];
export const MAX_DOCUMENT_BYTES = 10 * 1024 * 1024;

const authorization = () => {
    let token = null;
    try {
        token = localStorage.getItem("token");
    } catch {
        token = null;
    }
    return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getMyDocuments = async () => {
    const { data } = await client.get("/representant/me/documents", { headers: authorization(), skipSessionExpiry: true });
    return data;
};

/** `files` : { COMPANY_REGISTRATION: File, … } ; une partie multipart par type de pièce. */
export const uploadMyDocuments = async (files) => {
    const form = new FormData();
    Object.entries(files).forEach(([type, file]) => form.append(type, file));
    const { data } = await client.post("/representant/me/documents", form, { headers: authorization(), skipSessionExpiry: true });
    return data;
};
